import { useEffect } from "react";

/** Helpers */
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { useTranslation } from "react-i18next";
import { GenerateMeta } from "@/src/_common/useHelper";

/** Nextjs */
import dynamic from "next/dynamic";
import Head from "next/head";

/** MUI */
import { NoSsr } from "@mui/material";

/** Redux */

/** UI */
import MetaHeadSEO from "@/src/_common/MetaHeadSEO";
import ValuesIndex from "../../src/pages/CatalogPage/ValuesIndex";
const CatalogLayout = dynamic(() => import("../../src/layouts/CatalogLayout/CatalogLayout"));

const ValuesPage = (props) => {
    const { metaTitle, metaDescription } = props;
    // process.env.NODE_ENV === "development" && console.log(`%c ValuesPage `, "background: #000; color: #FFF;");
    const { t } = useTranslation();

    /** states */
    /** - redux */

    return (
        <CatalogLayout>
            {/* <Head>
                <title>{`${t("Dane o wysokiej wartości")} | DBW`}</title>
                <meta name="description" content="DBW description" />
                <link rel="icon" href="/favicon.ico" />
            </Head> */}
            <MetaHeadSEO metaTitle={metaTitle} metaDescription={metaDescription} />
            <NoSsr>
                <ValuesIndex />
            </NoSsr>
        </CatalogLayout>
    );
};

export async function getStaticProps({ locale }) {
    const _metas = GenerateMeta({ pageId: "hvd", locale });
    const { metaTitle, metaDescription } = _metas || {};
    return {
        props: {
            metaTitle,
            metaDescription,
            ...(await serverSideTranslations(locale, ["common"])),
            namespacesRequired: ["common"],
        },
        revalidate: false,
    };
}

export default ValuesPage;
